var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "c-search-box",
        { attrs: { isShowSearch: false }, on: { enter: _vm.getList } },
        [
          _c("template", { slot: "search" }, [
            _c(
              "div",
              { staticClass: "col-6" },
              [
                _c("c-plant", {
                  attrs: { type: "search", name: "plantCd" },
                  on: { input: _vm.getList },
                  model: {
                    value: _vm.popupParam.plantCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.popupParam, "plantCd", $$v)
                    },
                    expression: "popupParam.plantCd",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-6" },
              [
                _c("c-dept", {
                  attrs: {
                    type: "search",
                    label: "발의부서",
                    name: "initiativeDeptCd",
                  },
                  on: { input: _vm.getList },
                  model: {
                    value: _vm.searchParam.initiativeDeptCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "initiativeDeptCd", $$v)
                    },
                    expression: "searchParam.initiativeDeptCd",
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        2
      ),
      _c("c-table", {
        ref: "table",
        attrs: {
          columns: _vm.grid.columns,
          selection: _vm.popupParam.type,
          gridHeight: _vm.grid.height,
          data: _vm.grid.data,
          rowKey: "sopMocId",
          filtering: true,
          columnSetting: false,
          isFullScreen: false,
          isTitle: false,
        },
      }),
      _c("div", { staticClass: "space-bottom-button" }),
      _c(
        "div",
        { staticClass: "search-box-btn" },
        [
          _c(
            "q-btn-group",
            { attrs: { outline: "" } },
            [
              _c("c-btn", {
                attrs: { label: "선택", icon: "check", color: "teal-5" },
                on: { btnClicked: _vm.select },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }